import PopupState, {bindMenu, bindTrigger} from 'material-ui-popup-state';
import React from 'react';
import {useFormContext} from 'react-hook-form';

import {Menu, MenuItem} from '@mui/material';

import {palette} from 'styles/mui/scss';

import {Box} from 'components/basic-components';
import {CustomIcon} from 'components/basic-components/CustomIcon/CustomIcon';

import {SortMenuItem} from './SortMenuItem';

export const SortDropDown = () => {
  const {getValues, setValue} = useFormContext();
  const {sort} = getValues();

  return (
    <PopupState variant="popover" popupId="demo-popup-menu">
      {popupState => (
        <React.Fragment>
          <Box
            {...bindTrigger(popupState)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: palette.colorLightGrey,
              padding: '10px',
              cursor: 'pointer',
              borderRadius: '4px',
              width: '125px',
              justifyContent: 'center',
            }}
          >
            <CustomIcon name="bars" style={{height: '24px', width: '24px', marginRight: '5px'}} />
            <SortMenuItem sort={sort} />
          </Box>
          <Menu {...bindMenu(popupState)}>
            <MenuItem
              sx={{width: '125px', justifyContent: 'flex-end'}}
              onClick={() => {
                setValue('sort', 0);
                popupState.close();
              }}
            >
              <SortMenuItem sort={0} />
            </MenuItem>
            <MenuItem
              sx={{width: '125px', justifyContent: 'flex-end'}}
              onClick={() => {
                setValue('sort', 1);
                popupState.close();
              }}
            >
              <SortMenuItem sort={1} />
            </MenuItem>
            <MenuItem
              sx={{width: '125px', justifyContent: 'flex-end'}}
              onClick={() => {
                setValue('sort', -1);
                popupState.close();
              }}
            >
              <SortMenuItem sort={-1} />
            </MenuItem>
          </Menu>
        </React.Fragment>
      )}
    </PopupState>
  );
};
